// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2Ep57","label":"CategoryService_label__2zYUR","location":"CategoryService_location__wAT_z"};